<script>
    import I18n from '@js/modules/translations';

    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON, PLACE_ICON} from '@js/components/themes/icons';
    import locateMeIcon from '@js/components/icons/locateMeIcon';
    import historyIcon from '@js/components/icons/historyIcon';

    import {resolveUserPosition} from '@js/modules/userPosition';

    const {
        rideTypes = [],
        recentSearches = [],
        onSearch
    } = $props();

    let isLocating = $state(false);

    // Same compact chip as the filters
    const CHIP_CLASS = 'inline-flex shrink-0 items-center gap-1 px-3 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-full hover:bg-gray-50 cursor-pointer disabled:opacity-60';

    const searchAround = (center, rideType) => {
        onSearch({
            query: '*',
            queryDisplay: I18n.t('js.search.index.quick_start.near_me'),
            location: center ? {center} : null,
            nearMe: !!center,
            filters: rideType ? {rideTypes: [rideType]} : {}
        });
    };

    // Every chip searches around the same position (one resolver, asked once per session)
    const searchNearMe = async (rideType) => {
        isLocating = true;
        const position = await resolveUserPosition();
        isLocating = false;

        searchAround(position?.center || null, rideType);
    };
</script>

<div class="space-y-4">
    <div>
        <h2 class="m-0 mb-2 text-sm font-semibold text-gray-700">
            {I18n.t('js.search.index.quick_start.title')}
        </h2>

        <!-- One line: scrolls sideways on a narrow screen rather than wrapping -->
        <div class="flex items-center gap-1.5 overflow-x-auto pb-1">
            <button type="button"
                    class={CHIP_CLASS}
                    disabled={isLocating}
                    aria-busy={isLocating}
                    onclick={() => searchNearMe()}>
                <Icon class="w-3.5 h-3.5 text-primary-700"
                      icon={locateMeIcon}/>
                {I18n.t('js.search.index.quick_start.near_me')}
            </button>

            {#each rideTypes as rideType (rideType)}
                <button type="button"
                        class={CHIP_CLASS}
                        disabled={isLocating}
                        onclick={() => searchNearMe(rideType)}>
                    <Icon class="w-3.5 h-3.5 text-primary-700"
                          icon={RIDE_TYPE_ICON[rideType]}/>
                    {I18n.t('js.ride.enums.ride_type')[rideType]}
                </button>
            {/each}
        </div>
    </div>

    {#if recentSearches.length}
        <div>
            <h2 class="m-0 mb-2 text-sm font-semibold text-gray-700">
                {I18n.t('js.search.index.quick_start.recent')}
            </h2>

            <ul class="flex items-center flex-wrap gap-1.5">
                {#each recentSearches as recentSearch (recentSearch.queryDisplay)}
                    <li>
                        <button type="button"
                                class={CHIP_CLASS}
                                onclick={() => onSearch(recentSearch)}>
                            <Icon class="w-3.5 h-3.5 text-gray-500"
                                  icon={recentSearch.location ? PLACE_ICON.place : historyIcon}/>
                            {recentSearch.queryDisplay}
                        </button>
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
</div>
